<template>
  <v-container
    fluid
    style="background: linear-gradient(#043339, #D9D9D9, #052947); min-height: 100vh;"
    class="mt-n16"
  >
    <!-- DESKTOP -->
    <div class="d-none d-lg-block">
      <v-row class="mt-10 mx-16 px-16">
        <v-col cols="12" md="8">
          <span
            style="font-family: Montserrat !important;"
            class="text-h1 text-white font-weight-bold"
          >
            "Meet our blog
          </span>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="searchText"
            hide-details
            density="compact"
            rounded
            single-line
            prepend-inner-icon="mdi-magnify"
            class="shrink mx-4 white mt-8"
            style="background-color: white; border-radius: 20px;"
            @blur="search"
          />
        </v-col>
      </v-row>

      <v-img
        width="70px"
        style="z-index: 100; position: fixed; right: 0; top: 20%;"
        src="@/assets/covers/laterais.svg"
      />

      <!-- Sem resultados -->
      <v-container v-if="getArticles.length === 0" style="height: 100vh;">
        <span
          class="text-h2 primary--text text-center py-16"
          style="margin: auto; display: block;"
        >
          (Sem resultados)
        </span>
      </v-container>

      <!-- Lista artigos -->
      <v-row
        v-for="(article, index) in getArticles"
        :key="article.id"
        justify="center"
        no-gutters
        class="ma-0 pa-0"
      >
        <div class="triangle" v-if="drawBigTriangle(index) && getArticles.length > 1" />
        <div v-if="drawGrayGreen(index)">
          <div class="green-triangle" />
          <div class="gray-triangle" />
        </div>
        <div v-if="drawWhiteOrange(index)">
          <div class="orange-triangle" />
          <div class="beje-triangle" />
        </div>

        <v-col cols="10" class="py-10 my-10" style="z-index: 3;">
          <v-card height="500px" flat class="transparent">
            <v-row class="ma-0 pa-0">
              <!-- Imagem -->
              <v-col cols="6" class="ma-0 pa-0">
                <v-img
                  height="500px"
                  class="rounded-xl elevation-24"
                  :src="articleImg(article)"
                  cover
                />
              </v-col>

              <!-- Conteúdo -->
              <v-col cols="6" class="ma-0 pa-0">
                <v-card flat class="transparent ma-0 pa-0 fill-height">
                  <v-card-title
                    class="font-weight-black text-uppercase text-h4"
                    style="word-break: keep-all; color:#052947;"
                    v-html="article.title"
                  />
                  <v-card-subtitle
                    class="font-weight-black text-h6"
                    style="word-break: keep-all; color:#052947;"
                    v-html="article.subtitle"
                  />
                  <v-card-text
                    class="text-body-1"
                    style="word-break: keep-all; color:#052947;"
                    v-html="textArticle(article)"
                  />
                  <v-card-actions style="bottom: 0; position: absolute; width: 100%;">
                    <div class="text-subtitle-1" style="width: 100%;">
                      <v-row class="ml-2">
                        <v-col cols="auto" class="ma-0 pa-0">
                          <v-avatar>
                            <v-img cover :src="authorImg(article)" alt="Autor" />
                          </v-avatar>
                        </v-col>
                        <v-col cols="auto" class="ma-0 pa-0">
                          <div>
                            <span class="font-weight-bold ml-2" style="color:#052947">
                              {{ article.autor }}<template v-if="article.autor && article.data"> - </template>{{ article.data }}
                            </span>
                            <br />
                            <gb-social-button
                              v-if="article.author_id != null"
                              @click="openSocialNetwork('linkedin', $getSocialNetwork(article.author_id, 'Linkedin'))"
                              network="linkedin"
                              size="small"
                              :reverse="true"
                              theme="light"
                              style="border: none;"
                            />
                          </div>
                        </v-col>
                      </v-row>

                      <v-btn
                        @click="goToArticle(article)"
                        style="float: right; background-color: #094A59;"
                        class="text-white"
                      >
                        {{ t('blog.see_more') }}
                      </v-btn>
                    </div>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <!-- Load more -->
      <v-container fluid>
        <v-btn
          v-if="getArticles.length > 0 && articles.length > maximumLoad"
          style="margin: auto; display: block;"
          color="#567E9F"
          class="text-white font-weight-bold"
          @click="maximumLoad += maximumLoad"
        >
          Continuar a ler
        </v-btn>
      </v-container>
    </div>

    <!-- MOBILE -->
    <div class="d-lg-none mt-16">
      <v-row>
        <v-col cols="12" class="text-center mt-10">
          <span
            style="font-family: Montserrat !important;"
            class="text-h1 text-white font-weight-bold"
          >
            "Meet our blog
          </span>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="searchText"
            hide-details
            density="compact"
            rounded
            single-line
            prepend-inner-icon="mdi-magnify"
            class="shrink mx-4 white mt-8"
            style="background-color: white; border-radius: 20px;"
            @blur="search"
          />
        </v-col>
      </v-row>

      <v-img
        width="25px"
        style="z-index: 100; position: fixed; right: 0; top: 20%;"
        src="@/assets/covers/laterais.svg"
      />

      <v-container v-if="getArticles.length === 0">
        <span
          class="text-h2 primary--text text-center py-16"
          style="margin: auto; display: block;"
        >
          (Sem resultados)
        </span>
      </v-container>

      <v-row v-for="article in getArticles" :key="article.id" >
        <v-col cols="12" style="z-index: 3;" class="my-16 py-16">
          <v-card flat class="transparent">
            <v-img
              height="250px"
              :src="articleImg(article)"
              cover
            />
            <v-card-title
              class="font-weight-black text-uppercase text-h5 text-center"
              style="color:#052947;"
              v-html="article.title"
            />
            <v-card-subtitle
              class="font-weight-black text-h6"
              style="color:#052947;"
              v-html="article.subtitle"
            />
            <v-card-text
              class="text-body-1"
              style="color:#052947;"
              v-html="textArticle(article, true)"
            />

            <v-card-actions>
              <v-row class="ml-2">
                <v-col cols="auto" class="ma-0 pa-0">
                  <v-avatar>
                    <v-img cover :src="authorImg(article)" alt="Autor" />
                  </v-avatar>
                </v-col>
                <v-col cols="auto" class="ma-0 pa-0">
                  <div>
                    <span class="font-weight-bold ml-2" style="color:#052947">
                      {{ article.autor }}<template v-if="article.autor && article.data"> - </template>{{ article.data }}
                    </span>
                    <br />
                    <gb-social-button
                      v-if="article.author_id != null"
                      @click="openSocialNetwork('linkedin', $getSocialNetwork(article.author_id, 'Linkedin'))"
                      network="linkedin"
                      size="small"
                      :reverse="true"
                      theme="light"
                      style="border: none;"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row no-gutters justify="center" class="mt-4">
                <v-col cols="6">
                  <v-btn
                    block
                    style="background-color: #094A59;"
                    class="text-white"
                    @click="goToArticle(article)"
                  > 
                    {{ t('blog.see_more') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <v-container fluid>
        <v-btn
          v-if="getArticles.length > 0 && articles.length > maximumLoad"
          style="margin: auto; display: block;"
          color="#567E9F"
          class="text-white font-weight-bold"
          @click="maximumLoad += maximumLoad"
        >
          Continuar a ler
        </v-btn>
      </v-container>
    </div>
  </v-container>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import ARTICLES from '@/json_articles/articles.json'

const { t, locale } = useI18n()
const router = useRouter()

const articles = ref([])
const dataArticles = ref([])
const searchText = ref('')
const maximumLoad = ref(5)
const stepperLoad = ref(6) // (mantive caso uses noutro lado)
const positionY = ref(0)

onMounted(() => {
  articles.value = ARTICLES.articles
  search()
  window.scrollTo(0, 0)
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})

function search () {
  const arr = []
  articles.value.forEach(el => {
    const loc = locale.value
    if (el[loc]?.title?.includes(searchText.value)) {
      arr.push(el)
    }
  })
  dataArticles.value = arr
}

function goToArticle(article) {
  router.push(`/${locale.value}/blog/article/${article.id}`)
}

function handleScroll () {
  positionY.value = window.scrollY
}

function textArticle (t, mobile = false) {
  let aux = t.body.replaceAll('<br/>', '')
  let max_size = mobile ? 500 : 400
  return aux.length > max_size ? aux.substring(0, max_size) + '...' : aux
}

function openSocialNetwork (social, link) {
  if (social === 'linkedin') window.open(link, '_blank')
}

function drawBigTriangle (num) {
  return num !== 0 && num % 5 === 0
}
function drawGrayGreen (num) {
  return num !== 0 && num % 3 === 0
}
function drawWhiteOrange (num) {
  return num !== 0 && num % 4 === 0
}

// --- helpers ---
function slugify (s = '') {
  return s
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // tira acentos
    .replace(/\s+/g, '-')                              // espaços -> hífen
    .replace(/[^a-zA-Z0-9\-]/g, '')                    // limpa restos
}

// Mantém o objeto do artigo com um slug calculado
const getArticles = computed(() => {
  const loc = locale.value
  return dataArticles.value
    .map(el => {
      const a = el[loc]
      return { ...a, __slug: slugify(a.id) }
    })
    .slice(0, maximumLoad.value)
})

// <script setup>

// 1) Cria "contexts" para o webpack carregar tudo dessas pastas
const articleImgCtx = require.context('@/json_articles/images', true, /\.(png|jpe?g|gif|svg)$/i)
const authorImgCtx  = require.context('@/json_articles/autores', false, /\.(png|jpe?g|gif|svg)$/i)

// 2) Usa-os para resolver o caminho em runtime
function articleImg (article) {
  // pastas têm o mesmo nome do article.id (slug), e o ficheiro vem de article.foto
  const key = `./${article.id}/${article.foto}`
  try { return articleImgCtx(key) } catch (e) { return '' }
}

function authorImg (article) {
  const key = `./${article.autor_photo}`
  try { return authorImgCtx(key) } catch (e) { return '' }
}


</script>

<style>
.gb-social-button__focuser {
  border: none !important;
}
.triangle {
  width: 0;
  height: 0;
  border: 350px solid transparent;
  border-top: 0;
  border-bottom: 600px solid #E98459;
  position: absolute;
  left: -15vh;
  margin-top: 20vh;
  z-index: 2;
}
.green-triangle {
  width: 0;
  height: 0;
  border: 50px solid transparent;
  border-top: 0;
  border-bottom: 120px solid #0A4E56;
  position: absolute;
  rotate: -110deg;
  left: 20vh;
  z-index: 1;
}
.gray-triangle {
  width: 0;
  height: 0;
  border: 30px solid transparent;
  border-top: 0;
  border-bottom: 80px solid #858585;
  position: absolute;
  rotate: 60deg;
  left: 10vh;
  margin-top: 10vh;
  z-index: 1;
}
.orange-triangle {
  width: 0;
  height: 0;
  border: 30px solid transparent;
  border-top: 0;
  border-bottom: 80px solid #E76012;
  position: absolute;
  rotate: 15deg;
  left: 10vh;
  z-index: 1;
}
.beje-triangle {
  width: 0;
  height: 0;
  border: 30px solid transparent;
  border-top: 0;
  border-bottom: 80px solid #EAEAE9;
  position: absolute;
  rotate: 110deg;
  left: 0;
  z-index: 1;
}
</style>
